import { Navigate } from 'react-router-dom';

/* eslint-disable-next-line */
export type NoMatchProps = {};

export const NoMatch: React.FC<NoMatchProps> = (props) => {
  return <Navigate to={'/ca/en'} />;
};
